/* Packs proposés à partir des articles du panier. Aucune mutation du panier. */
(function (root) {
  'use strict';
  function recommend(cart, packs) {
    const items = cart.items || [];
    const byHandle = new Map(packs.map(p => [p.h, p]));
    const present = new Set();
    const expanded = new Set();
    items.forEach(item => {
      const h = item.handle || (item.url || '').split('/products/')[1]?.split('?')[0];
      if (!h) return;
      present.add(h);
      (byHandle.get(h)?.parts || [h]).forEach(x => expanded.add(x));
    });
    // 17/09 lot 2b : un pack deja au panier, on n'en propose pas un autre qui le recouvre ; le bloc se tait.
    if ([...present].some(h => byHandle.has(h))) return [];
    return packs.filter(p => !present.has(p.h) && !p.parts.every(x => expanded.has(x)))
      .map(p => ({...p, overlap: p.parts.filter(x => expanded.has(x)).length}))
      .sort((a,b) => (b.overlap > 0) - (a.overlap > 0) || a.rank - b.rank)
      .slice(0,2);
  }
  if (typeof module !== 'undefined' && module.exports) { module.exports = {recommend}; return; }
  const packs = root.ESL_PACKS || [];
  const esc = s => String(s ?? '').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const money = n => (n/100).toFixed(2).replace('.',',')+' €';
  function html(cart) {
    const offers=recommend(cart,packs);
    if (!offers.length) return '';
    return '<h3>Et si vous choisissiez un pack ?</h3>'+offers.map(p=>
      '<article class="esl-cart-pack"><a href="'+esc(p.u)+'" tabindex="-1" aria-hidden="true"><img src="'+esc(p.i)+'" width="72" height="72" alt="" loading="lazy"></a><div><strong>'+esc(p.t)+'</strong><p>'+esc(p.desc)+'</p><b>'+money(p.p)+'</b>'+
      
      (p.overlap?'<p class="esl-pack-overlap">Contient '+p.overlap+' référence'+(p.overlap>1?'s':'')+' déjà dans votre panier. Comparez avant d’ajouter le pack.</p>':'')+
      '<a class="esl-pack-link" href="'+esc(p.u)+'">Voir le pack et son contenu →</a></div></article>').join('');
  }
  function update(cart) {
    const lines=document.querySelector('.cart-drawer .cart-lines');
    if (lines) {
      let block=lines.querySelector('[data-esl-cart-packs]');
      if (!block) {block=document.createElement('section');block.dataset.eslCartPacks='';block.className='esl-cart-packs';lines.appendChild(block);}
      block.innerHTML=html(cart);block.hidden=!block.innerHTML;
    }
    document.querySelectorAll('[data-esl-cart-packs-page]').forEach(block=>{block.innerHTML=html(cart);block.hidden=!block.innerHTML;});
  }
  document.addEventListener('cart:change',e=>update(e.detail || {}));
  if(document.querySelector('[data-esl-cart-packs-page]')) fetch('/cart.js',{headers:{Accept:'application/json'}}).then(r=>{if(!r.ok)throw Error();return r.json();}).then(update).catch(()=>{});
})(typeof window === 'undefined' ? globalThis : window);
